"use client";

import Script from "next/script";
import { useEffect, useState } from "react";

/** `gtag` is the GTM web container id (e.g. GTM-XXXX). GA4/Ads are configured inside GTM. */
export default function HeadClient({ gtag }: { gtag: string }) {
  const [mounted, setMounted] = useState(false);
  const [isWhy2How, setIsWhy2How] = useState(false);
  const containerId = (gtag ?? "").trim();

  useEffect(() => {
    setMounted(true);
    setIsWhy2How(window.location.hostname === "why2how.tech");
  }, []);

  useEffect(() => {
    if (!isWhy2How) return;
    try {
      // @ts-ignore
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch (err) {
      console.error("AdSense error:", err);
    }
  }, [isWhy2How]);

  if (!mounted) {
    return null;
  }

  return (
    <>
      {containerId ? (
        <Script id="google-tag-manager" strategy="lazyOnload">
          {`
          (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
          new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
          j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
          'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
          })(window,document,'script','dataLayer','${containerId}');
        `}
        </Script>
      ) : null}

      {isWhy2How && (
        <>
          <Script
            id="adsbygoogle-script"
            strategy="lazyOnload"
            async
            src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-9347766160012524"
            crossOrigin="anonymous"
          />
          <Script
            id="adsbygoogle-init"
            strategy="lazyOnload"
            dangerouslySetInnerHTML={{
              __html: `
                (adsbygoogle = window.adsbygoogle || []).push({});
              `,
            }}
          />
        </>
      )}
    </>
  );
}
